import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import { commercialRealEstateAllNews } from "@/data/commercialRealEstateAllNews";

const CommercialRealEstateNewsIndexPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="px-4 py-8 sm:py-12">
        <div className="mx-auto max-w-6xl">
          <Link
            to="/#noticias"
            className="inline-flex items-center gap-2 text-sm font-black text-[#0056D2] transition hover:text-blue-700"
          >
            <ArrowLeft className="h-4 w-4" />
            Regresar
          </Link>

          <div className="mt-6 mb-6">
            <p className="text-xs font-black uppercase tracking-wide text-[#0056D2]">
              Tulocalmx te informa
            </p>
            <h1 className="mt-1 text-3xl font-black leading-tight text-slate-950 sm:text-5xl">
              Noticias que mueven el mercado
            </h1>
            <p className="mt-3 max-w-2xl text-sm font-semibold leading-6 text-slate-600">
              Datos, tendencias e ideas sobre IA, rentas, retail y espacios comerciales.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
            {commercialRealEstateAllNews.map((item) => (
              <button
                key={item.slug}
                type="button"
                onClick={() => navigate(`/noticias/${item.slug}`)}
                className="group overflow-hidden rounded-md border border-slate-200 bg-white text-left shadow-sm transition hover:-translate-y-0.5 hover:border-orange-200 hover:shadow-md"
              >
                <div className={`relative h-28 bg-gradient-to-r ${item.accent}`}>
                  <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(255,255,255,0.28),transparent_28%),linear-gradient(135deg,rgba(255,255,255,0.16),transparent_45%)]" />
                  <div className="absolute left-4 top-4 rounded-sm border border-white/40 bg-white/95 px-2 py-1 text-[10px] font-black uppercase text-slate-900 shadow-sm">
                    {item.tag}
                  </div>
                </div>

                <div className="p-4">
                  <h2 className="line-clamp-2 text-base font-black leading-snug text-slate-950">
                    {item.title}
                  </h2>
                  <p className="mt-2 line-clamp-2 text-sm font-semibold leading-6 text-slate-600">
                    {item.summary}
                  </p>
                  <div className="mt-3 flex items-center justify-between gap-3 border-t border-slate-100 pt-3">
                    <span className="text-xs font-bold text-slate-500">Fuente: {item.sourceName}</span>
                    <span className="inline-flex items-center gap-1 text-xs font-black uppercase text-[#F97316]">
                      Leer nota
                      <ArrowRight className="h-3.5 w-3.5 transition group-hover:translate-x-0.5" />
                    </span>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
};

export default CommercialRealEstateNewsIndexPage;
